export default __webpack_public_path__ + "static/media/triangle.6b4926a3.svg";